// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"0986e6f6","739":"19521626"}[chunkId] + ".chunk.css";
};